import { selectProduct } from "@/store/slices/product";
import React from "react";
import { useSelector } from "react-redux";
import styles from "./title.module.scss";

const ProductDetailsTitle = () => {
  const productState = useSelector(selectProduct);

  if (!productState.data) {
    return <></>;
  }

  const stock = productState.selectedPrice?.stock ?? 0;
  const blockStock = productState.selectedPrice?.block_stock ?? 0;
  const leftInStock = stock - blockStock;

  return (
    <>
    <div className="w-100">
      <h1 className={styles.product_title}>{productState.data.title}</h1>
      {leftInStock > 0 && (
        <small className={styles.stock_alert}>
          {leftInStock > 5 ? 5 : leftInStock} left in stock
        </small>
      )}
      <span className={styles.product_link}>SKU: {productState.data.sku}</span>
    </div>
    </>
  );
};

export default ProductDetailsTitle;
